export default function TradeInComparison() {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A2332] mb-4">
              Trade-In vs. Private Sale: The Honest Truth
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Yes, you might get a bit more selling privately. But is it worth the hassle? Let's do the math on your sanity.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Private Sale */}
            <div className="bg-white rounded-xl p-8 border-2 border-slate-200">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-2xl text-slate-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1A2332]">Private Sale</h3>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-[#1A2332]">Potentially $1,000-2,000 more</div>
                    <div className="text-sm text-slate-600">If you find the right buyer and they don't flake</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-[#1A2332]">Weeks of "is this still available?" texts</div>
                    <div className="text-sm text-slate-600">Spoiler: they never show up</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-[#1A2332]">Strangers test-driving your car</div>
                    <div className="text-sm text-slate-600">Hope you like awkward small talk</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-[#1A2332]">Payment scams and lowball offers</div>
                    <div className="text-sm text-slate-600">"My cousin will pick it up next week with cash"</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-[#1A2332]">You're still making payments</div>
                    <div className="text-sm text-slate-600">While waiting for it to sell</div>
                  </div>
                </div>
              </div>

              <div className="bg-slate-50 rounded-lg p-4 text-center">
                <div className="text-sm font-semibold text-slate-700">Time Investment</div>
                <div className="text-2xl font-bold text-[#1A2332] mt-1">4-8 weeks</div>
              </div>
            </div>

            {/* Trade-In */}
            <div className="bg-gradient-to-br from-[#1A2332] to-[#243044] rounded-xl p-8 border-2 border-[#F5C842]/40 relative">
              <div className="absolute -top-3 -right-3 bg-[#F5C842] text-[#1A2332] px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                WAY LESS STRESS
              </div>

              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-[#F5C842] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-exchange-line text-2xl text-[#1A2332]"></i>
                </div>
                <h3 className="text-2xl font-bold text-white">Trade-In with Us</h3>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#F5C842] text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-white">Fair market value offer</div>
                    <div className="text-sm text-white/70">Based on actual data, not dealer lowball tactics</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#F5C842] text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-white">Done in one visit</div>
                    <div className="text-sm text-white/70">Drive your old car in, drive your new car out</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#F5C842] text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-white">We handle the payoff</div>
                    <div className="text-sm text-white/70">Still owe money? We'll deal with your lender</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#F5C842] text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-white">No strangers, no scams</div>
                    <div className="text-sm text-white/70">Just a straightforward transaction</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#F5C842] text-xl mt-1"></i>
                  <div>
                    <div className="font-semibold text-white">Apply it toward your next car</div>
                    <div className="text-sm text-white/70">Trade value goes directly toward your purchase price</div>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 rounded-lg p-4 text-center border border-[#F5C842]/30">
                <div className="text-sm font-semibold text-white/80">Time Investment</div>
                <div className="text-2xl font-bold text-[#F5C842] mt-1">1 day</div>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-[#1A2332] rounded-xl p-8 text-center border-2 border-[#F5C842]/30">
            <h3 className="text-2xl font-bold text-white mb-3">
              The Bottom Line
            </h3>
            <p className="text-white/80 mb-6 max-w-2xl mx-auto">
              Sure, you might pocket an extra grand selling privately. But after weeks of no-shows, lowball offers, and "my mechanic needs to look at it first" — is it really worth it? We'll give you a fair price and get you into your next car today. Your time is worth something too.
            </p>
            <a
              href="#trade-in-form"
              className="inline-flex items-center gap-2 bg-[#F5C842] text-[#1A2332] px-8 py-4 rounded-lg font-bold hover:bg-[#E8B84B] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Get Your Trade-In Value
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
